var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',_vm._b({attrs:{"name":"localModal","classes":"v--modal vmodal-container","height":_vm.height,"scrollable":true,"transition":"nice-modal-fade","adaptive":true,"clickToClose":_vm.clickToClose},on:{"closed":_vm.closeModal}},'v-modal',_vm.$attrs,false),[_c('div',{attrs:{"slot":"top-right"},slot:"top-right"},[(_vm.clickToClose)?_c('md-button',{staticClass:"md-round md-just-icon md-danger",on:{"click":_vm.closeModal}},[_c('md-icon',[_vm._v("close")])],1):_vm._e()],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/SimpleModal.vue